import mainStyle from "../../mainStyle.module.scss";
import React, { useState, useEffect } from 'react';
import { useTheme } from "@mui/material/styles";
import { Typography, Box, TextField, InputAdornment } from "@mui/material";

// import close from "assets/img/icon/icn_nav_close.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";

const MfaPhase1 = (props) => {
  const {
    setInputPw, checkResponse
  } = props;
  const theme = useTheme();

  const [currentPw, setCurrentPw] = useState('')
  const [ifNgCurrentPw, setIfNgCurrentPw] = useState(false)
  const [currentPwErr, setCurrentPwErr] = useState('')
  const [showCurrentPw, setShowCurrentPw] = useState(false)

  const handleCurrentPw = (e) => {
    let tmpVal = e.target.value;
    setCurrentPw(tmpVal)
    setInputPw(tmpVal)
  }
  const handleShowCurrentPw = (e) => {
    let tmpVal = showCurrentPw;
    setShowCurrentPw(!tmpVal)
  }
  const replaceVariableMsg = (originMsg, target, replaceAry) =>{
    let index = 0;

    // 對 target 進行正則轉譯
    // function escapeRegExp(string) {
    //   return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // }
    // escapeRegExp(target);
    const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const targetRegex = new RegExp(escapedTarget, 'g');

    return originMsg.replace(targetRegex, () => {
      return index < replaceAry.length ? replaceAry[index++] : target;
    });
  }

  const handleBlurCurrentPw = () => {
    if(currentPw === ''){
      setIfNgCurrentPw(true)
      setCurrentPwErr('Please enter your password')
    }else{
      setIfNgCurrentPw(false)
      setCurrentPwErr('')
    }
  }

  useEffect(() => {
    if (checkResponse.status === 'error') {
      setIfNgCurrentPw(true);

      const errMsg = checkResponse.msg;

      if (errMsg.includes('||||')) {
        const [tmpMsgRaw, replaceVarRaw] = errMsg.split('||||');
        const tmpMsg = tmpMsgRaw.trim();
        const replaceVar = replaceVarRaw.trim();
        const targetStr = '%d'
        const replacedMsg = replaceVariableMsg(tmpMsg, targetStr, replaceVar);
        setCurrentPwErr(replacedMsg);
      } else {
        setCurrentPwErr(errMsg);
      }
    } else {
      setIfNgCurrentPw(false);
      setCurrentPwErr('');
    }
  }, [checkResponse]);

  return (
    <>
      <div className={mainStyle['modal_rows']} >
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Enter your account password to proceed.
          </Typography>
        </div>
      </div>
      <div className={mainStyle['modal_rows']} >
        <div style={{marginTop: '15px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Password
          </Typography>
          <Box sx={{}}>
            <TextField
              error={ifNgCurrentPw}
              value={currentPw}
              fullWidth
              placeholder=""
              type={showCurrentPw? 'text': 'password'}
              size="small"
              onChange={(e) => handleCurrentPw(e)}
              onBlur={handleBlurCurrentPw}
              variant="outlined"
              sx={{
                mr: 1,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px', // 改變圓角
                  '& fieldset': {
                    borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                  },
                  "&:hover fieldset": {
                    borderColor: theme.palette.primary.mainHover,
                  },
                  "&.Mui-focused fieldset": {
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                  },
                },
              }}
              inputProps={{style: {fontSize: '13px'}}}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {!showCurrentPw && <HideIcon onClick={handleShowCurrentPw} style={{cursor:'pointer'}}/>}
                    {showCurrentPw && <ShowIcon onClick={handleShowCurrentPw} style={{cursor:'pointer'}}/>}
                  </InputAdornment>
                ),
              }}
              style={{margin:'5px 0px'}}
              autoComplete="off"
            />
          </Box>
          {currentPwErr && 
            <Typography
              sx={{
                color: theme.palette.primary.redPrimary,
                fontSize: theme.typography.customFontSize[3],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              {currentPwErr}
            </Typography>
          }
        </div>
      </div>
    </>
  );
}

export default MfaPhase1;